module.exports = __webpack_public_path__ + "media/images/index/feature/top-aoj-b-293efddd260ab7cc292a43b9095101d8.png";